import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getBusinessRelationInformation } from 'services/businessRelationService';
import { CoreDataDto } from 'types/BrTypes';
import { isNotNullOrUndefined } from 'utils/utils';
import { brQueryRetry, brQueryRetryDelay } from 'hooks/queries/brFetchRetry';

export function useFetchBr(brId?: string) {
  return useQuery<CoreDataDto, AxiosError>({
    queryKey: ['getBr', brId],
    queryFn: () => getBusinessRelationInformation(brId),
    retry: brQueryRetry,
    retryDelay: brQueryRetryDelay,
    enabled: isNotNullOrUndefined(brId),
  });
}
